import { createSelector } from '@ngrx/store';

export const getFinancialInstitutionsState = createSelector(
    (state: any) => state.financialInstitutions,
    (state: any) => state.get('list')
);

export const getCreateFinancialInstitutionState = createSelector(
    (state: any) => state.financialInstitutions,
    (state: any) => state.get('createFinancialInstitution')
);

export const getUpdateFinancialInstitutionState = createSelector(
    (state: any) => state.financialInstitutions,
    (state: any) => state.get('updateFinancialInstitution')
);
 